/**
 * AnalyticsTracker — Invisible component that tracks page views on route changes.
 * Place near root, inside <BrowserRouter>.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../../utils/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => { initGA(); }, []);

  useEffect(() => {
    // Small delay to let react-helmet-async update <title> before we read it
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 120);
    return () => clearTimeout(t);
  }, [location]);

  return null;
};

export default AnalyticsTracker;
